export default "__VITE_ASSET__Caw$tBwY__"